import { toast } from "sonner";
import { formatApiErrorDetail } from "./api";

export const notify = {
  success: (msg) => toast.success(msg),
  error: (msg) => toast.error(msg),
  info: (msg) => toast(msg),
};

export async function withToast(fn, { success = "Kaydedildi", error = "İşlem başarısız" } = {}) {
  try {
    const result = await fn();
    toast.success(success);
    return result;
  } catch (e) {
    toast.error(formatApiErrorDetail(e?.response?.data?.detail) || error);
    throw e;
  }
}
